module.exports = __webpack_public_path__ + "img/ic_upload_File_1_active.131c0164.svg";